const firebaseConfig = {
    apiKey: "AIzaSyD1IrBonYU323IhAG1MP6d6dihLHdhpjuI",
    authDomain: "doctors-house-1ec0a.firebaseapp.com",
    projectId: "doctors-house-1ec0a",
    storageBucket: "doctors-house-1ec0a.appspot.com",
    messagingSenderId: "650218289575",
    appId: "1:650218289575:web:6b2f43e8955d6e8193de82"
};

export default firebaseConfig;